import store from '@/store';

export const mapUnitConfiguration = props => {
	return props.reduce((acc, prop) => {
		acc[prop] = () => store.getters['unitConfiguration/data'](prop);
		return acc;
	}, {});
};
